import React from 'react';
import Routing from "./routing";
import AppLayout from "@meridian/components/app-layout";
import Column from "@meridian/components/column";
import AppTopNavigation from "./components/app-top-navigation";
import AppContextProvider from "./context/app-context";
import withDevSupport from "./dev-support";

export default function App() {
    return <AppContextProvider>
        <AppLayout>
            {withDevSupport(
                <Column id={"container"} width="100%" height="100%" spacing="none">
                    <AppTopNavigation/>
                    <Column className="container" height="100%" heights="fill">
                        <Routing/>
                    </Column>
                </Column>
            )}
        </AppLayout>
    </AppContextProvider>;
}



// WEBPACK FOOTER //
// ./src/app.js